<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container " style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Personal Info</li>
        </ol>
      </nav>

      <p>&zwnj;</p>

      <h2 class="title_fontStyle "><i class="fas fa-caret-right"></i> Personal Info</h2>
      <p>&zwnj;</p>

      <div class="row mb-3">
        <div class="col-lg-6 px-4">
          <div>
            <h5 class="form_title">
              Email
            </h5>
            <p style="font-size:19px">
              {{ email }}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="row mt-4">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="signupName" class="form_title ">Name <span class="redpoint">*</span></label>

            <input
              class="form-control form-control-lg"
              type="text"
              id="signupName"
              maxlength="30"
              v-model="name"
              name="name"
              :class="{ 'is-invalid': errors.first('name') }"
              v-validate="'required'"
              ref="signupName"
            />
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('name')"
              ><i class="fas fa-exclamation-triangle"></i> The Name field is required
            </span>
          </div>
        </div>

        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="signupcompany" class="form_title "> Company <span class="redpoint">*</span></label>

            <input
              class="form-control form-control-lg"
              type="text"
              placeholder="Please enter your company name"
              id="signupcompany"
              maxlength="60"
              v-model="Company"
              name="Company"
              :class="{ 'is-invalid': errors.first('Company') }"
              v-validate="'required'"
              ref="signupcompany"
            />
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('Company')"
              ><i class="fas fa-exclamation-triangle"></i> The Company field is required
            </span>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-6  px-4">
          <div class="form-group mb-4">
            <label for="inputDepartment" class="form_title ">Department</label>

            <input
              class="form-control form-control-lg"
              type="text"
              id="inputDepartment"
              maxlength="30"
              v-model="Department"
            />
          </div>
        </div>

        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label class="form_title ">Title <span class="redpoint">*</span></label>
            <select
              class="form-control form-control-lg text-dark"
              v-model="optionTitle"
              name="title"
              :class="{ 'is-invalid': errors.first('title') }"
              v-validate="'required'"
            >
              <option value="">-- Select --</option>
              <option v-for="item in TitleCategory" :value="item.eJobPosition">{{ item.eJobPosition }} </option>
            </select>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('title')"
              ><i class="fas fa-exclamation-triangle"></i> The Title field is required
            </span>

            <div v-if="titleOtr" class="mt-2">
              <input
                class="form-control form-control-lg"
                type="text"
                maxlength="100"
                placeholder="Please enter your title"
                v-model="titleOtherContnet"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="inputDepartment2" class="form_title ">Company Address <span class="redpoint">*</span></label>

            <select
              class="form-control form-control-lg text-dark mb-3"
              v-model="optionCompanyCountry"
              name="CompanyAddress"
              :class="{ 'is-invalid': errors.first('CompanyAddress') }"
              v-validate="'required'"
            >
              <option value="">-- Please Choose Country/Region --</option>
              <option value="TW">Taiwan</option>
              <option value="CN">China</option>
              <option value="HK">Hong Kong</option>
              <option value="MY">Malaysia</option>
              <option value="JP">Japan</option>
              <option value="US">United States</option>
              <option value="SG">Singapore</option>
              <option value="KR">South Korea</option>
              <option value="ID">Indonesia</option>
              <option value="TH">Thailand</option>
              <option value="VN">Vietnam</option>

              <option value="xx" disabled> ------------------------------------</option>
              <option v-for="item in CountryCategory" :value="item.Country_Code">{{ item.eCountry }} </option>
            </select>

            <span class="text-danger" style="font-size: 10px" v-if="errors.first('CompanyAddress')"
              ><i class="fas fa-exclamation-triangle"></i> The company country field is required
            </span>

            <div v-if="optionCompanyCountry == 'TW'">
              <select
                class="form-control form-control-lg text-dark mb-3"
                v-model="optionPostalCode"
                name="CompanyPostalCode"
                :class="{ 'is-invalid': errors.first('CompanyPostalCode') }"
                v-validate="'required'"
              >
                <option value="">-- Post Code --</option>
                <option v-for="item in PostalCodeCategory" :value="item.PostalCode"
                  >{{ item.PostalCode }} {{ item.ePostalName }}</option
                >
              </select>

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('CompanyPostalCode')"
                ><i class="fas fa-exclamation-triangle"></i> The postalCode field is required
              </span>
            </div>

            <input
              class="form-control form-control-lg"
              type="text"
              id="inputDepartment2"
              maxlength="100"
              v-model="CompanyAddress"
              name="address"
              :class="{ 'is-invalid': errors.first('address') }"
              v-validate="'required'"
              placeholder="Please enter company address"
            />

            <span class="text-danger" style="font-size: 10px" v-if="errors.first('address')"
              ><i class="fas fa-exclamation-triangle"></i> The Address field is required
            </span>
          </div>
        </div>

        <div class="col-lg-6  px-4">
          <div class="form-group mb-4">
            <label class="form_title ">Company Tel</label>

            <div class="row">
              <div class="col-8">
                <input
                  class="form-control form-control-lg"
                  type="text"
                  placeholder="eg. 886-2-26596000"
                  maxlength="15"
                  v-model="CompanyTel"
                />
              </div>

              <div class="col-4">
                <input
                  class="form-control form-control-lg"
                  type="text"
                  placeholder="ext."
                  maxlength="6"
                  v-model="CompanyExt"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="btn btn-primary px-5 py-2 mt-4 mb-3" @click.prevent="ChangeProfile()">Submit</div>
      <p>&zwnj;</p>
      <p>&zwnj;</p>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        Validcode: '',
        CSRF_Token: '',
        name: '',
        email: '',

        allPhone: '',
        bindProps: {
          mode: 'international',
        },

        Company: '',
        Department: '',
        CompanyTel: '',
        CompanyExt: '',
        CompanyAddress: '',

        CountryCategory: [],
        PostalCodeCategory: [],
        TitleCategory: [],
        CompanyIndusCategory: [],

        optionCompanyCountry: '', //選擇國家
        optionPostalCode: '', //選擇郵遞區號
        optionTitle: '', //選擇職稱
        optionCompanyIndus: '', //選擇公司行業

        CompanyIndusOtr: false,
        titleOtr: false,
        titleOtherContnet: '',
        CompanyIndusContent: '',
        ProfileList: {},
      }
    },

    methods: {
      reload() {
        window.location.reload()
      },
      ChangeProfile() {
        const vm = this

        const signupinfo = {
          name: vm.name,
          CompanyIndustry: '',
          CompanyIndustry_Oth: '',
          Company: vm.Company,
          Dept: vm.Department,
          Position: vm.optionTitle,
          Position_oth: '',
          Tel: vm.CompanyTel,
          Ext: vm.CompanyExt,
          PoBox: vm.optionPostalCode,
          Address: vm.CompanyAddress,
          Country: vm.optionCompanyCountry,
          CSRF: vm.CSRF_Token,
        }

        const url = 'https://www.chanchao.com.tw/apiOnlineExpo/v1/Editcompanyinformation'

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, signupinfo).then(function(response) {
              if (response.data == '200') {
                vm.alertTitle = 'Success'
                vm.alertText = 'Your profile has been updated'
                vm.alertSuccessSignup()
              } else if (response.data == '252') {
                window.location.replace(`https://www.chanchao.com.tw/en/`)
              } else if (response.data == '253') {
                vm.alertText = 'Exhibition does not exists.'

                vm.alertError()
              } else if (response.data == '254') {
                vm.alertText = 'Please log in first to complete the visitor online registration.'

                vm.alertError()
              } else if (response.data == '255') {
                vm.alertText = 'Email Error'

                vm.alertError()
              } else {
                vm.alertText = ' Error, please check your data and login again.'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccessSignup() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          window.location.replace('https://www.chanchao.com.tw/coffee/onlineexpo/Edit')
        })
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    watch: {
      optionTitle: function(newValue) {
        if (newValue.includes('Other')) {
          this.titleOtr = true
        } else {
          this.titleOtr = false
        }
      },

      optionCompanyIndus: function(newValue) {
        if (newValue.includes('99')) {
          this.CompanyIndusOtr = true
        } else {
          this.CompanyIndusOtr = false
        }
      },
    },

    created() {
      $('.modal').modal('hide')

      const vm = this
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      vm.$http.get('https://www.chanchao.com.tw/apiOnlineExpo/v1/Validcode_Token/GetValidateCode').then((response) => {
        vm.Validcode = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Countries?Lang=en').then((response) => {
        vm.CountryCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/PostalCodes').then((response) => {
        vm.PostalCodeCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Titles?Lang=en').then((response) => {
        vm.TitleCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/CompanyIndustrys?Lang=en').then((response) => {
        vm.CompanyIndusCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
        vm.email = response.data.email
        vm.name = response.data.cname
        vm.Company = response.data.company
        vm.CompanyAddress = response.data.address
        vm.optionPostalCode = response.data.PoBox
        vm.optionCompanyCountry = response.data.country
        vm.optionTitle = response.data.title
        vm.Department = response.data.Division
        vm.CompanyTel = response.data.Tel
        vm.CompanyExt = response.data.Ext

        //手機組合

        let mobilenum = response.data.mobile
        let mobArea = response.data.MobileCountryCode
        vm.allPhone = '+' + mobArea + mobilenum

        //title中文轉英文

        let titleCn = response.data.title
        if (titleCn == '一般職員') {
          vm.optionTitle = 'Officer / Assistant'
        } else if (titleCn == '負責人/董事長') {
          vm.optionTitle = 'Owner / President'
        } else if (titleCn == '股東/合夥人') {
          vm.optionTitle = 'Stockholder / Co-Founder'
        } else if (titleCn == '高階管理階級 (CEO、COO、CTO、總經理…等)') {
          vm.optionTitle = 'Top Management (CEO、COO、CTO、GM…etc)'
        } else if (titleCn == '高階特別助理') {
          vm.optionTitle = 'Executive Assistant'
        } else if (titleCn == '總監/副總經理') {
          vm.optionTitle = 'Vice President / Director'
        } else if (titleCn == '經理/專案經理') {
          vm.optionTitle = 'Manager'
        } else if (titleCn == '基層管理階層 (副理、主任、課長、組長…等)') {
          vm.optionTitle = 'First-line Management (Assistant Manager、Supervisor、Team Leader…etc)'
        } else if (titleCn == '資深專員/管理師') {
          vm.optionTitle = 'Specialist / Senior Officer'
        } else if (titleCn == '其他') {
          //需確認other回傳的值
          vm.optionTitle = 'Other'
        } else {
          vm.optionTitle = response.data.title
        }
      })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  input {
    line-height: 38px;
    padding-left: 20px;
    font-size: 20px;
  }

  .form-control.is-invalid,
  .was-validated .form-control:invalid {
    background-position: right calc(0.375em + 0.8rem) center;
  }
</style>
